import { render, staticRenderFns } from "./AgreementHistoryItem.vue?vue&type=template&id=45780d78&scoped=true"
import script from "./AgreementHistoryItem.vue?vue&type=script&lang=ts"
export * from "./AgreementHistoryItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45780d78",
  null
  
)

export default component.exports